import { Component, OnInit, Input } from "@angular/core";
import { ProgramEditorService } from "../program-editor.service";
import { TypesService } from "../../types.service";
import { Subscription } from "rxjs/Subscription";

import { ActNowDictionaryItem } from "@models/common";
import {
    Program,
    ProgramServices,
    ProgramTimings,
    ProgramGradesServed,
    ProgramProgramsOffered,
    ProgramMealsServed
} from "@models/program";

@Component({
    templateUrl: "./program-services-editor.component.html",
    selector: "app-program-services-editor"
})

export class ProgramServicesEditorComponent implements OnInit {
    @Input() reviewing = false;
    public baseColumns: number = 6;

    public communitySchoolsTooltip: string = Program.communitySchoolsTooltip;

    public model: ProgramServices;
    public dataReadySub: Subscription;
    constructor(private editorService: ProgramEditorService, private typeService: TypesService) { }

    ngOnInit(): void {
        if (this.reviewing) {
            this.baseColumns = 12;
        }
        this.editorService.updateCurrentTab(3);
        this.getData();
    }

    getData(): void {
        let ready = this.editorService.dataReady;
        if (ready) {
            let program = this.editorService.getProgram();
            if (program.services == undefined) {
                this.model = new ProgramServices();
            } else {
                this.model = program.services;
            }

            if (this.model.timing == undefined) {
                this.model.timing = new ProgramTimings();
            }
            if (this.model.gradesServed == undefined) {
                this.model.gradesServed = new ProgramGradesServed();
            }
            if (this.model.programsOffered == undefined) {
                this.model.programsOffered = new ProgramProgramsOffered();
            }
            if (this.model.mealsServed == undefined) {
                this.model.mealsServed = new ProgramMealsServed();
            }

            if (this.model.mealsServed.snacks == undefined) {
                this.model.mealsServed.snacks = 1;
            }
            if (this.model.mealsServed.breakfast == undefined) {
                this.model.mealsServed.breakfast = 1;
            }
            if (this.model.mealsServed.lunch == undefined) {
                this.model.mealsServed.lunch = 1;
            }
            if (this.model.mealsServed.dinner == undefined) {
                this.model.mealsServed.dinner = 1;
            }
            this.updateModel();
            if (this.dataReadySub != undefined) {
                this.dataReadySub.unsubscribe();
            }
        } else {
            this.dataReadySub = this.editorService.dataReady$.subscribe(x => this.getData());
        }
    }

    changeOther(): void {
        if (!this.model.programsOffered.other) {
            this.model.programsOffered.programTypeOther = undefined;
        }
    }

    updateMeals(meal: number, option: number): void {
        meal = +meal;
        option = +option;
        switch (meal) {
            case 1:
                this.model.mealsServed.snacks = option;
                break;
            case 2:
                this.model.mealsServed.breakfast = option;
                break;
            case 3:
                this.model.mealsServed.lunch = option;
                break;
            case 4:
                this.model.mealsServed.dinner = option;
                break;
        }

        this.updateModel();
    }

    updateModel(): void {
        let program = this.editorService.getProgram();
        program.services = this.model;
        this.editorService.updateProgram(program);
    }

}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/common/program-editors/services/program-services-editor.component.ts